import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { Text } from '@thumbtack/thumbprint-react';
import { UL, LI } from 'components/mdx';
export const pageQuery = graphql`
    {
        allMdx(
            filter: { fileAbsolutePath: { glob: "**/src/pages/updates/notes/20*.mdx" } }
            sort: { order: DESC, fields: fileAbsolutePath }
        ) {
            edges {
                node {
                    frontmatter {
                        title
                    }
                    parent {
                        ... on File {
                            relativeDirectory
                            name
                        }
                    }
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <UL mdxType="UL">
    {props.data.allMdx.edges.map(({
        node
      }) => <LI key={node.parent.name} mdxType="LI">
            <a href={`/updates/notes/${node.parent.name}/`}>
                {node.frontmatter.title} {}
            </a>
        </LI>)}
    </UL>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      